export default __webpack_public_path__ + "static/Fellix-RegularItalic-ddee3c42b2c09610fd47343d31b02b64.otf";